import { Mail, Send } from 'lucide-react';
import { BAND_EMAIL } from '../constants/contact';

export function ContactPage() {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);

        const name = formData.get('name') as string;
        const email = formData.get('email') as string;
        const message = formData.get('message') as string;

        // Create mailto link
        const mailtoLink = `mailto:${BAND_EMAIL}?subject=Message from ${encodeURIComponent(name)}&body=${encodeURIComponent(message)}%0D%0A%0D%0AFrom: ${encodeURIComponent(email)}`;
        window.location.href = mailtoLink;

        // Reset form
        form.reset();
    };

    return (
        <div className="max-w-2xl mx-auto px-4 py-12">
            <div className="text-center mb-8">
                <Mail className="w-12 h-12 mx-auto mb-4 text-primary" />
                <h2 className="mb-2 text-primary text-3xl font-bold">Get In Touch</h2>
                <p className="text-foreground max-w-2xl mx-auto opacity-75">
                    Have a question or want to book us for a show? Send us a message!
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label htmlFor="name" className="block text-sm font-medium mb-2 text-foreground">
                        Name
                    </label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        required
                        placeholder="Your name"
                        className="w-full px-3 py-2 bg-input border border-border text-foreground placeholder-muted-foreground rounded-lg focus:outline-none focus:border-primary transition-colors"
                    />
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm font-medium mb-2 text-foreground">
                        Email
                    </label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        placeholder="your.email@example.com"
                        className="w-full px-3 py-2 bg-input border border-border text-foreground placeholder-muted-foreground rounded-lg focus:outline-none focus:border-primary transition-colors"
                    />
                </div>

                <div>
                    <label htmlFor="message" className="block text-sm font-medium mb-2 text-foreground">
                        Message
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        required
                        placeholder="Your message..."
                        rows={6}
                        className="w-full px-3 py-2 bg-input border border-border text-foreground placeholder-muted-foreground rounded-lg focus:outline-none focus:border-primary transition-colors resize-none"
                    />
                </div>

                <p className="text-sm text-muted-foreground text-center">
                    We respect your privacy. Your contact information will only be used to respond to your inquiry and
                    will not be shared with third parties. This site uses Google Analytics to understand visitor
                    behavior.
                </p>

                <button
                    type="submit"
                    className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-semibold uppercase tracking-wider hover:opacity-90 transition-opacity rounded"
                >
                    <Send className="w-5 h-5" />
                    Send Message
                </button>
            </form>

            <div className="mt-12 pt-12 border-t border-border">
                <div className="text-center">
                    <h3 className="text-lg font-semibold mb-4 text-primary">Direct Contact</h3>
                    <a
                        href={`mailto:${BAND_EMAIL}`}
                        className="inline-flex items-center gap-2 text-primary hover:opacity-80 transition-opacity"
                    >
                        <Mail className="w-5 h-5" />
                        {BAND_EMAIL}
                    </a>
                </div>
            </div>
        </div>
    );
}
